/* cwc-floating-box */
$position-bottom: var(--cwc-floating-box-position-bottom, 7rem) !default;
$position-right: var(--cwc-floating-box-position-right, 2rem) !default;
$background-color: var(--cwc-floating-box-background-color, #ffff) !default;
$background-color-hover: var(--cwc-floating-box-background-color-hover, #ffff) !default;
$min-width: var(--cwc-floating-box-min-width, 470px) !default;
$max-width: var(--cwc-floating-box-max-width, 25vw) !default;
$min-height: var(--cwc-floating-box-min-height, 330px) !default;
$z-index: var(--cwc-floating-box-z-index, auto) !default;

// csc-mixins
@use '~@cewe-designsystem-stylecomponents/mixins/shadows' as shadows;

:host {
  @extend %sg-cw-shadow-layer-01;
  display: inline;
  position: fixed;
  z-index: $z-index;
  right: $position-right;
  bottom: $position-bottom;
  min-width: $min-width;
  max-width: $max-width;
  min-height: $min-height;
  transform: translateX(10px);
  transition:
    opacity 500ms ease-in-out,
    transform 500ms ease-in-out;
  opacity: 0;
  pointer-events: none;

  cwc-floating-box-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    transition: background-color 250ms ease-in-out;
    border-radius: 4px;
    background-color: $background-color;

    &:hover {
      background-color: $background-color-hover;
    }

    cwc-floating-box-header {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      width: 100%;
    }

    cwc-floating-box-body {
      display: flex;
      flex-direction: column;
      padding: 0 1rem 1rem;
      font-size: 1rem;
      line-height: 1.4;
    }
  }

  cwc-floating-box-close {
    display: flex;
    justify-content: center;
    fill: currentColor;
    cursor: pointer;

    slot[name='close-icon'] {
      display: inline-flex;
      margin: 0.75rem;
    }

    /* stylelint-disable-next-line selector-max-compound-selectors */
    slot[name='close-icon'] > *,
    ::slotted(*) {
      width: 1.1rem;
    }
  }
}

:host([opened]) {
  transform: translateX(0);
  opacity: 1;
  pointer-events: auto;
}

/* prevent flickering within default-theme -> earlyGlobal.css */
//cwc-floating-box:not(.hydrated) {
//  display: none;
//}
